import { Alert } from "@gravity-ui/uikit";
import { Helmet } from "react-helmet";
import { appConfig } from "src/config";

import { CertScanner } from "./widgets/CertScanner/CertScanner.tsx";

export const ScannerPage = () => {
  return (
    <section>
      <Helmet>
        <title>{appConfig.displayName} · Консоль · Сканер</title>
      </Helmet>
      <Alert
        theme="info"
        title={
          "Наведите камеру устройства на QR-код сертификата и проверьте его подлинность"
        }
      />
      <CertScanner />
    </section>
  );
};
